import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationSubscriptionsDeleteSubscription = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
